module.exports = __webpack_public_path__ + "static/media/apartment15.23f24e88.jpg";